import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../features/user";
import paisApi from "../../utility/api/paisApi";
import useQuery from "../../utility/useQuery";
import Swal from "sweetalert2";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import Input from "../../components/Input";
import ButtonClasses from "../../components/Button/typing";
import CancelarButton from "../../components/CancelarButton";
import { NotAllowed, permissoes, useAthorize } from "../../hooks/useAthorize";

const EdicaoPaises = ({ setIsVisible, onFinished }) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm();

  let isAllowed = useAthorize(
    permissoes.localizacaoConsulta,
    permissoes.localizacaoFull
  );

  const query = useQuery();
  let paisId = parseInt(query.get("paisId") ?? 0);

  const token = useSelector(selectUserToken);

  const onSubmit = useCallback(
    async ({ nome }) => {
      let data = {
        paisId,
        nome,
      };

      let result = await paisApi.atualizarPais(data, token);

      if (result.hasError) {
        Swal.fire({
          title: "Erro!",
          text: "Algo deu errado",
          icon: "error",
        });
        return;
      }

      if (result.data.length === 0) {
        reset(data);
        onFinished?.();

        Swal.fire({
          title: "Sucesso!",
          text: "Cadastrado com sucesso",
          icon: "success",
        });
        return;
      }

      Swal.fire({
        title: "Erro!",
        text: result.data,
        icon: "error",
      });
    },
    [onFinished, paisId, reset, token]
  );

  const fetchPais = useCallback(async () => {
    var result = await paisApi.buscarPais(paisId, token);

    if (result.hasError) {
      Swal.fire({
        title: "Erro!",
        text: "Algo deu errado",
        icon: "error",
      });
      return;
    }

    reset(result.data);
  }, [paisId, reset, token]);

  useEffect(() => {
    fetchPais();
  }, [fetchPais]);

  var footer = (
    <>
      <CancelarButton
        watch={watch}
        reset={() =>
          Swal.fire({
            text: "Realmente deseja cancelar o cadastro?",
            showDenyButton: true,
            confirmButtonText: "Sim",
            denyButtonText: `Não`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              reset();

              Swal.fire({
                text: "Cancelado com sucesso!",
                icon: "success",
              });
            }
          })
        }
        getValues={getValues}
        voltar={() => setIsVisible()}
      />
      <Button
        colorClass={ButtonClasses.DarkGreen}
        text="Salvar"
        onClick={handleSubmit(onSubmit)}
      />
    </>
  );

  if (!isAllowed) return <NotAllowed />;

  return (
    <Modal setModal={setIsVisible} title="Edição de País" footer={footer}>
      <div className="w-full h-full flex justify-center items-center">
        <form onSubmit={handleSubmit(onSubmit)} className="w-[86%]">
          <div className="grid grid-cols-1 gap-8">
            <Input
              label="País"
              name="nome"
              type="text"
              placeholder="Insira o nome do país"
              register={register}
              required
              errors={errors}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EdicaoPaises;
